import React from 'react';
import PropTypes from 'prop-types';

import './point-message.css';

// example message structure: '<module>: <name> ({ <json details> })'
// CLEANER: STD CONVERSION EXCEPTION ({\"value\": 163.0, \"from_unit\": \"F\", \"to_unit\": \"in W.C.\", \"exception\": \"To Unit in W.C. not found in conversion lookup for F\"})"

const msg = /(.*): (.*) \({(.*)\}\)/;

const renderMessages = (msgList) => {
  if (!msgList) return null;
  // only show the first 10 messages (elevator points can have hundreds because of 1s polling)
  return msgList.slice(0, 10).map((m, i) => {
    const match = m.match(msg);
    if (!match) return m;
    const [, mod, name, details] = match;
    return (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={`${i}-${details}`}>
        <span className="module">{mod}</span>
        {' - '}
        <span className="name">{name}</span>
        {' - '}
        <span className="details">{details}</span>
        <br />
      </React.Fragment>
    );
  });
};

// renderer for messages added to the table by the unit conversion code
const renderConversion = (message) => {
  if (!message?.message) {
    return null;
  }
  return (
    <>
      <span className="module">UNITS</span>
      {' - '}
      <span className="name">
        {message.message} ({message.err_type})
      </span>
      {' - '}
      <span className="details">{message.extra}</span>
    </>
  );
};

/**
 * Component for breaking down and displaying the error strings sent to the api by
 * the data ingest pipeline or API conversion code
 */
const PointMessage = ({ message }) => {
  const { info, error } = message;
  return (
    <div className="point-message">
      <span className="errors">{renderMessages(error)}</span>
      <span className="infos">{renderMessages(info)}</span>
      <span className="conversion">{renderConversion(message)}</span>
    </div>
  );
};

PointMessage.propTypes = {
  message: PropTypes.shape({
    info: PropTypes.arrayOf(PropTypes.string),
    error: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default PointMessage;
